import { Col, Row } from 'antd'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { getDuration } from '../../common/util/helper'

class MarkerInfo extends React.Component {
  getCreditOffsets () {
    const {markers, compositionDuration, getDurationFromEnd} = this.props
    const markerDataStyle = 'qw-font-size-body qw-line-height-body qw-color-text-body'
    let creditOffsets = []
    if (markers.ffec) {
      creditOffsets.push(<p key='ffec'
                            className={markerDataStyle}>{I18n.t(`compositions.markers.ffec`)}&#58;&nbsp;
        {getDuration(markers.ffec)} (&minus;{getDurationFromEnd(compositionDuration, markers.ffec)})</p>)
    }

    if (markers.ffmc) {
      creditOffsets.push(<p key='ffmc'
                            className={markerDataStyle}>{I18n.t(`compositions.markers.ffmc`)}&#58;&nbsp;
        {getDuration(markers.ffmc)} (&minus;{getDurationFromEnd(compositionDuration, markers.ffmc)})</p>)
    }

    return creditOffsets
  }

  render () {
    const {compositionName, compositionDuration} = this.props
    return (
      <div className="marker-info">
        <Row
          className='composition-name qw-mb-large qw-font-size-body qw-bold qw-line-height-body qw-color-text-body'>
          <Col span={20} title={compositionName} className='qw-truncate'>{compositionName}</Col>
          <Col span={4} className='qw-right-align'>{getDuration(compositionDuration)}</Col>
        </Row>
        <p
          className="marker-title qw-font-size-small qw-color-text-secondary-heading qw-line-height-small">{I18n.t(`compositions.cplMarkers`)} / {I18n.t(`compositions.creditsOffset`)}</p>
        {this.getCreditOffsets()}
      </div>
    )
  }
}

export default MarkerInfo



// WEBPACK FOOTER //
// ./src/app/components/compositions/MarkerInfo.js